<template>
  <div id="chooseAddress">
    <div class="province">
      <address-item
        :title="proTitle"
        :value="province"
        :list="provinceList"
        :handlerSelect="selectProvince"
        :isClick="pIsClick"
      />
    </div>
    <div class="city">
      <address-item
        :title="cityTitle"
        :value="city"
        :list="cityList"
        :handlerSelect="selectCity"
        :isClick="cIsClick"
      ></address-item>
    </div>
    <div class="district">
      <address-item
        :title="disTitle"
        :value="district"
        :list="districtList"
        v-model:list="districtList"
        :handlerSelect="selectDistrict"
        :isClick="dIsClick"
      ></address-item>
    </div>
  </div>
</template>

<script>
import { getAreaList } from "@/service/area";
import { reactive, toRefs, onMounted, watch } from "vue";
import AddressItem from "./AddressItem";
export default {
  name: "CompAddress",
  props: {
    province: {
      type: String,
      default: "不限",
    },
    provinceCode: {
      type: String,
      default: "",
    },
    district: {
      type: String,
      default: "不限",
    },
    districtCode: {
      type: String,
      default: "",
    },
    city: {
      type: String,
      default: "不限",
    },
    cityCode: {
      type: String,
      default: "",
    },
    selectArea: {
      type: Function,
    },
    type: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const state = reactive({
      areaData: {},
      proTitle: "省",
      province: props.province,
      provinceCode: props.provinceCode || "100000",

      cityTitle: "市",
      city: props.city,
      cityCode: props.cityCode,
      disTitle: "区",
      district: props.district,
      districtCode: props.districtCode,

      provinceList: {},
      cityList: {},
      districtList: {},

      pIsClick: true,
      cIsClick: true,
      dIsClick: true,
    });
    onMounted(async () => {
      getAreaData();
    });
    const getAreaData = async () => {
      const { data, code } = await getAreaList();
      if (code === 10000) {
        state.areaData = data;
        init();
      }
    };
    const init = async () => {
      const { provinceCode } = props;
      let pcode = provinceCode;
      if (!pcode) {
        pcode = 100000;
      }
      getProvince(pcode);
      if (props.province != "不限" && props.province != "") {
        const pcode = props.provinceCode;
        searchCity(props.province, pcode.substring(0, 4));
      }
      if (props.city != "" && props.city != "不限") {
        const ccode = props.cityCode;
        searchDistrict(props.city, ccode);
      }
    };
    watch(props, (newProps) => {
      const { province, provinceCode, city, cityCode, district, districtCode } =
        newProps;
      state.province = province;
      state.provinceCode = provinceCode;
      state.city = city;
      state.cityCode = cityCode;
      state.distric = district;
      state.district = districtCode;
      if (props.province != "不限" && props.province != "") {
        const pcode = props.provinceCode;
        searchCity(props.province, pcode.substring(0, 4));
      }
      if (props.city != "" && props.city != "不限") {
        const ccode = props.cityCode;
        searchDistrict(props.city, ccode);
      }
    });

    const getProvince = (code) => {
      if (!code) {
        return false;
      }
      const list = state.areaData[code];
      state.provinceList = Object.assign({ 0: "不限", ...list });
    };
    const selectProvince = (name, key) => {
      // console.log('name, key --> ', name, key)
      state.province = name;
      state.provinceCode = key;
      searchCity(name, key);
    };
    const searchCity = (name, code) => {
      if (!code) {
        return;
      }
      const list = state.areaData[code];
      state.cityList = Object.assign({ 0: "不限", ...list });
      state.districtList = Object.assign({ 0: "不限" });
      props.selectArea({
        province: name,
        provinceCode: code,
        city: "不限",
        cityCode: 0,
        district: "不限",
        districtCode: 0,
        cityList: list,
        districtList: null,
      });
    };

    const selectCity = (name, key) => {
      state.city = name;
      state.cityCode = key;

      searchDistrict(name, key);
    };
    const searchDistrict = (name, code) => {
      if (!code) {
        return;
      }
      const list = state.areaData[code];
      state.districtList = Object.assign({ 0: "不限", ...list });
      props.selectArea({
        city: name,
        cityCode: code,
        district: "不限",
        districtCode: 0,
        cityList: state.cityList,
        districtList: list,
      });
    };

    const selectDistrict = (name, key) => {
      state.district = name;
      state.districtCode = key;
      props.selectArea({
        district: name,
        districtCode: key,
        cityList: state.cityList,
        districtList: state.districtList,
      });
    };
    return {
      ...toRefs(state),
      close,
      getProvince,
      selectProvince,
      selectDistrict,
      selectCity,
    };
  },
  components: {
    AddressItem,
  },
};
</script>

<style lang="less" scoped>
.select_box {
  margin-right: 15px;
}
</style>
